import React, { useEffect, useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { MASTER_VERSION, URL_LOGIN } from '~/constant';
import logoRevoCrm from '~/Images/logo-crm-360.svg';
import appointment from '~/Images/appointment.svg';
import { CaretDown, MagnifyingGlass } from 'phosphor-react';
import getLinks, { URLV1, URLV2 } from './links';
import { MainNavbar } from './styles';
import {
  FaUser,
  FaLaptop,
  FaGavel,
  FaDollarSign,
  FaInfo,
  FaComments,
} from 'react-icons/fa';
import AuthStorage from '~/Utils/AuthStorage';
import * as api from '~/Services/Service';
import { EMPREENDIMENTO_LANCAMENTO } from '~/constant';
import { useLocation, Link } from 'react-router-dom';
import { getInitial } from '~/Utils/Helpers';
import BreadcrumbComponent from '../Breadcrumb/BreadcrumbComponent';
import ChatDepartamento from '../ChatDepartamento';
import { conectar as conectarSignalRChat } from '../ChatDepartamento/chatSignalR';
import { conectar as conectarLancamentoSignalR } from '~/Utils/LancamentoSignalR';

export default function NavbarHeader({ onLogout, user }) {
  const [dptoLancamento, setDptoLancamento] = useState(null);
  const [searchActive, setSearchActive] = useState(false);
  const [modoMobile, setModoMobile] = useState(window.innerWidth <= 768);
  const [chatAberto, setChatAberto] = useState(false);
  const [chatNaoLidas, setChatNaoLidas] = useState(0);
  const [chatSignalRMensagem, setChatSignalRMensagem] = useState(0);
  const [chatSignalRComunicado, setChatSignalRComunicado] = useState(0);

  useEffect(() => {
    if (window.innerWidth <= 770) {
      setModoMobile(true);
      return;
    }
    setModoMobile(false);
  }, [window.innerWidth]);

  const inicializarBotoesLancamento = () => {
    if (!AuthStorage.isAtendenteLancamento() || !AuthStorage.temAtendimentoAtivo()) return;
    setDptoLancamento({
      imobiliaria: { nome: 'Imobiliária', posicao: null },
      corretor: { nome: 'Corretor', posicao: null },
      apoio: null,
      ti: null,
      diretoria: null,
      juridico: null,
      financeiro: null,
    });
    if (EMPREENDIMENTO_LANCAMENTO > 0) {
      buscarMinhasSolicitacoesPendentes();
    }
  };

  useEffect(() => {
    inicializarBotoesLancamento();
    buscarContagemChat();
    conectarSignalRChat(
      () => buscarContagemChat(),
      () => setChatSignalRMensagem(prev => prev + 1),
      () => { buscarContagemChat(); setChatSignalRComunicado(prev => prev + 1); }
    );
    if (AuthStorage.isAtendenteLancamento() && AuthStorage.temAtendimentoAtivo()) {
      conectarLancamentoSignalR({
        AdicionarSolicitacao: () => buscarMinhasSolicitacoesPendentes(),
        RemoverSolicitacao: () => buscarMinhasSolicitacoesPendentes(),
      });
    }
  }, []);

  // Recarrega quando EMPREENDIMENTO_LANCAMENTO é carregado (assíncrono)
  useEffect(() => {
    if (AuthStorage.isAtendenteLancamento() && AuthStorage.temAtendimentoAtivo() && EMPREENDIMENTO_LANCAMENTO > 0) {
      buscarMinhasSolicitacoesPendentes();
    }
  }, [EMPREENDIMENTO_LANCAMENTO]);

  const buscarContagemChat = async () => {
    try {
      const result = await api.contarNaoLidasChat();
      setChatNaoLidas(result.total || 0);
    } catch (err) {}
  };

  const buscarMinhasSolicitacoesPendentes = async () => {
    try {
      const response = await api.consultarMinhasSolicitacoesPendentes();
      if (response) {
        setDptoLancamento(response);
      }
    } catch (err) {
      console.error('Erro ao buscar solicitações pendentes:', err);
    }
  };

  const clickDpto = async departamento => {
    const response = await api.NotificarDepartamento(departamento);
    setDptoLancamento(response);
  };

  const dicionario = {
    comercial: 'Comercial',
    relatorio: 'Relatório',
    comissao: 'Comissão',
    ranking: 'Ranking',
    corretor: 'Corretor',
    prospectos: 'Prospectos',
  };

  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const [horaAtual, setHoraAtual] = useState('');

  useEffect(() => {
    const atualizarHora = () => {
      const agora = new Date();
      const data = agora.toLocaleDateString('pt-BR');
      const horas = agora
        .getHours()
        .toString()
        .padStart(2, '0');
      const minutos = agora
        .getMinutes()
        .toString()
        .padStart(2, '0');
      setHoraAtual(`Horário do servidor: ${data} ${horas}h${minutos}`);
    };
    atualizarHora();
    const timer = setInterval(atualizarHora, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <MainNavbar fixed="top" expand="lg" variant="dark">
        <Navbar.Brand href={'/'}>
          <img className="crm-navbar-logo" src={logoRevoCrm} alt="Revo Brasil" />
        </Navbar.Brand>
        <div className="d-flex align-items-center">
          <div className="d-lg-none mr-2" style={{ position: 'relative' }}>
            <button
              className="btn-chat-navbar"
              onClick={() => setChatAberto(!chatAberto)}
              title="Chat Departamental"
            >
              <FaComments size={20} />
              {chatNaoLidas > 0 && (
                <span className="chat-badge">{chatNaoLidas}</span>
              )}
            </button>
            <ChatDepartamento
              show={chatAberto}
              onHide={() => { setChatAberto(false); buscarContagemChat(); }}
              onContagemAtualizada={setChatNaoLidas}
              signalRMensagem={chatSignalRMensagem}
              signalRComunicado={chatSignalRComunicado}
            />
          </div>
          <Navbar.Toggle className="border-0" />
        </div>

        <Navbar.Collapse className="crm-navbar-collapse">
          <Nav className="mr-auto crm-navbar-primary">
            {getLinks().map((item, index) =>
              item.dropdown ? (
                <NavDropdown
                  className="crm-dropdown"
                  title={
                    <div className="d-flex align-items-center">
                      <div className="mr-2">{item.icon}</div>
                      <span className="crm-dropdown-span">{item.label}</span>
                      <CaretDown
                        className="crm-dropdown-caret ml-1"
                        size={16}
                      />
                    </div>
                  }
                  id={`dropdown-${index}`}
                  key={index}
                >
                  {item.dropdown.map((ditem, dindex) =>
                    ditem.divider ? (
                      <NavDropdown.Divider key={dindex} />
                    ) : ditem.header ? (
                      <NavDropdown.Header key={dindex}>
                        {ditem.header}
                      </NavDropdown.Header>
                    ) : (
                      <NavDropdown.Item
                        key={dindex}
                        href={ditem.href}
                        className="crm-dropdown-item"
                      >
                        <span className="crm-dropdown-label">
                          {ditem.icon} {ditem.label}
                        </span>
                      </NavDropdown.Item>
                    )
                  )}
                </NavDropdown>
              ) : (
                <Nav.Link
                  target={item.target}
                  key={index}
                  href={item.href}
                  className="d-flex align-items-center"
                >
                  <span className="mr-2">{item.icon}</span>
                  <span>{item.label}</span>
                </Nav.Link>
              )
            )}

            {dptoLancamento && dptoLancamento.imobiliaria && (
              <>
                {/* <div className="nav-item item-dpto">
                <button
                  onClick={() => clickDpto('gerente')}
                  className={`nav-link ${
                    dptoLancamento.imobiliaria.posicao ? 'notificar' : ''
                  }`}
                >
                  {dptoLancamento.imobiliaria.nome}
                </button>
              </div> */}
                <div className="nav-item item-dpto">
                  <button
                    onClick={() => clickDpto('corretor')}
                    className={`nav-link ${
                      dptoLancamento.corretor.posicao ? 'notificar' : ''
                    }`}
                  >
                    {dptoLancamento.corretor.nome}
                  </button>
                </div>
                <div className="nav-item item-dpto">
                  <button
                    onClick={() => clickDpto('apoio')}
                    className={`nav-link ${
                      dptoLancamento.apoio ? 'notificar' : ''
                    }`}
                  >
                    <FaInfo />
                    <span className="visible-lg-inline">Apoio</span>
                  </button>
                  {dptoLancamento.apoio && (
                    <div className="posicao">{dptoLancamento.apoio}</div>
                  )}
                </div>
                <div className="nav-item item-dpto">
                  <button
                    onClick={() => clickDpto('ti')}
                    className={`nav-link ${
                      dptoLancamento.ti ? 'notificar' : ''
                    }`}
                  >
                    <FaLaptop /> <span className="visible-lg-inline">TI</span>
                  </button>
                  {dptoLancamento.ti && (
                    <div className="posicao">{dptoLancamento.ti}</div>
                  )}
                </div>
                <div className="nav-item item-dpto">
                  <button
                    onClick={() => clickDpto('diretoria')}
                    className={`nav-link ${
                      dptoLancamento.diretoria ? 'notificar' : ''
                    }`}
                  >
                    <FaUser />
                    <span className="visible-lg-inline">Diretoria</span>
                  </button>
                  {dptoLancamento.diretoria && (
                    <div className="posicao">{dptoLancamento.diretoria}</div>
                  )}
                </div>
                <div className="nav-item item-dpto">
                  <button
                    onClick={() => clickDpto('juridico')}
                    className={`nav-link ${
                      dptoLancamento.juridico ? 'notificar' : ''
                    }`}
                  >
                    <FaGavel />
                    <span className="visible-lg-inline">Jurídico</span>
                  </button>
                  {dptoLancamento.juridico && (
                    <div className="posicao">{dptoLancamento.juridico}</div>
                  )}
                </div>
                <div className="nav-item item-dpto">
                  <button
                    onClick={() => clickDpto('financeiro')}
                    className={`nav-link ${
                      dptoLancamento.financeiro ? 'notificar' : ''
                    }`}
                  >
                    <FaDollarSign />
                    <span className="visible-lg-inline">Financeiro</span>
                  </button>
                  {dptoLancamento.financeiro && (
                    <div className="posicao">{dptoLancamento.financeiro}</div>
                  )}
                </div>
              </>
            )}
          </Nav>
          <div
            className="d-none d-lg-flex align-items-center mr-2 crm-navbar-chat-desktop"
            style={{ position: 'relative' }}
          >
            <button
              className="btn-chat-navbar"
              onClick={() => setChatAberto(!chatAberto)}
              title="Chat Departamental"
            >
              <FaComments size={20} />
              <span>Chat</span>
              {chatNaoLidas > 0 && (
                <span className="chat-badge">{chatNaoLidas}</span>
              )}
            </button>
            <ChatDepartamento
              show={chatAberto}
              onHide={() => { setChatAberto(false); buscarContagemChat(); }}
              onContagemAtualizada={setChatNaoLidas}
              signalRMensagem={chatSignalRMensagem}
              signalRComunicado={chatSignalRComunicado}
            />
          </div>
          <Nav className="crm-navbar-profile-nav">
            <NavDropdown
              className="crm-dropdown crm-dropdown-profile"
              alignRight
              title={
                <div className="d-flex align-items-center">
                  <div
                    className="profile-container d-flex align-items-center"
                    style={{ cursor: 'pointer' }}
                    title={
                      '#' +
                      AuthStorage.getUser().usuario +
                      ' ' +
                      AuthStorage.getUser().nome
                    }
                  >
                    {AuthStorage.getUser().url_foto ? (
                      <div className="profile-circle">
                        <img
                          src={AuthStorage.getUser().url_foto}
                          alt="Perfil"
                        />
                      </div>
                    ) : (
                      <div
                        className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center me-2"
                        style={{
                          width: 40,
                          height: 40,
                          fontWeight: 'bold',
                          fontSize: '0.8rem',
                          borderRadius: '50%',
                        }}
                      >
                        {getInitial(AuthStorage.getUser().nome)}
                      </div>
                    )}
                  </div>
                  <div className="d-flex align-items-center">
                    <CaretDown className="crm-dropdown-caret ml-1" size={16} />
                  </div>
                </div>
              }
            >
              {!AuthStorage.isCorretorDesligado() && (
                <NavDropdown.Item
                  className="crm-dropdown-item"
                  href={`${URLV1}/Prospectos/Agendamentos/Consultar.aspx`}
                >
                  <span className="crm-dropdown-label">Agendamentos</span>
                </NavDropdown.Item>
              )}
              {false && (
                <NavDropdown.Item
                  href={`${URLV2}/agendamento`}
                  className="crm-dropdown-item"
                >
                  <img src={appointment} alt="Agendamentos" />
                  <span className="crm-dropdown-label">Agendamentos</span>
                </NavDropdown.Item>
              )}

              <NavDropdown.Item
                href={`/usuario/alterar-senha`}
                className="crm-dropdown-item"
              >
                <span className="crm-dropdown-label">Alterar senha</span>
              </NavDropdown.Item>

              {/* <NavDropdown.Item
                href={`${URLV1}/Usuarios/AlterarSenha.aspx`}
                className="crm-dropdown-item"
              >
                <span className="crm-dropdown-label">Alterar senha</span>
              </NavDropdown.Item> */}

              <NavDropdown.Divider />
              <NavDropdown.Item
                onClick={onLogout}
                href={`${URL_LOGIN}`}
                className="crm-dropdown-item"
              >
                <span className="crm-dropdown-label">Sair</span>
              </NavDropdown.Item>

              <NavDropdown.Divider />
              <NavDropdown.Item
                className="crm-dropdown-item-no-hover"
                style={{
                  pointerEvents: 'none',
                  cursor: 'default',
                  width: '100%',
                  textAlign: 'left',
                }}
              >
                <small
                  className="crm-dropdown-label"
                  style={{ display: 'block', color: '#999' }}
                >
                  {AuthStorage.getUser().nome}
                </small>
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </MainNavbar>

      {/* <nav
        className="py-1 pl-3 d-flex flex-wrap align-items-center justify-content-between"
        style={{ backgroundColor: 'rgba(234, 241, 249, 1)' }}
      >
        <BreadcrumbComponent />
      </nav> */}
    </>
  );
}
